import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { AppModule }              from '../app.module';

import * as ent from '../entities/index'
import * as serv from '../services/index'

//base
import { BaseDropdownComponent } from '../baseclasses/BaseDropdown.component';
import { BaseGridComponent } from '../baseclasses/BaseGrid.component';

import * as enums from '../enums/index'

export abstract class BaseControlGroupComponent implements OnInit{
    userInfo: ent.UserInfo;
    enableCustomerLookups: boolean;
    enableEquipmentLookups: boolean;
    authenticationService: serv.AuthenticationService;
    domainDataService: serv.DomainDataService;
    employeeService: serv.EmployeeService;
    request: ent.Request;
    @Input() requestTypeID?: number;
    ngOnInit() {
        
        
    };


    constructor(){
        this.authenticationService = AppModule.injector.get(serv.AuthenticationService);
        this.employeeService = AppModule.injector.get(serv.EmployeeService);
        this.domainDataService = AppModule.injector.get(serv.DomainDataService);
        this.userInfo = this.authenticationService.getUserInfo();
        this.enableCustomerLookups = this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.EnableCustomerLookups)[0].SettingValue == "true" ? true : false;
        this.enableEquipmentLookups = this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.EnableEquipmentLookups)[0].SettingValue == "true" ? true : false;

    }

    convertTime(time: string): Date{
        var hours = time.substr(0,2);
        var minutes = time.substr(3,2);
        var myDate = new Date();
        myDate.setMinutes(parseInt(minutes));
        myDate.setHours(parseInt(hours));
        myDate.setSeconds(0);
        return myDate;
    }

    //2020-03-25 LEB: The below RegExp will prevent all special characters except for #. Spaces are also allowed. Note that, as it's currently used, it won't prevent the user from pasting 
    //a string containing special characters into the given field; it will only prevent individual keystrokes of those characters.
    blockSpecial: RegExp = /^$|[^@\-$%^&*()<>/\+:'"?!_{}'|\.\\\[\],;\/=]+/;

    public collapsed: boolean;

    public customerLookupsEnabled(): boolean {
        return this.enableCustomerLookups;
        
    }
    public equipmentLookupsEnabled(): boolean {
        
        return this.enableEquipmentLookups;
    }

    @ViewChildren(BaseDropdownComponent) dropDowns: QueryList<BaseDropdownComponent>;
    @ViewChildren(BaseGridComponent) grids: QueryList<BaseGridComponent>;
    
    public loadDropDowns(){
        if (this.dropDowns){
            var dropdowns = this.dropDowns.toArray();
            
            for (var dropdown of dropdowns){
                dropdown.load();
            }
        }

        if (this.grids){
            var grids = this.grids.toArray();
            
            for (var grid of grids){
                grid.loadDropDowns();
            }
        }
    }

    
    public abstract setDates():void;

    public abstract setRequestInfo(request: ent.Request): void;

}

export default BaseControlGroupComponent;